import React from 'react';
import NobagDay  from 'views/NobagDay';

const Nep2020Guildeline = () => {
  return <NobagDay />;
};

export default Nep2020Guildeline;
